/**
 * Custom JavaScript for Nautilus Reels
 * Theme-wide customizations
 */

/* +++ Starting zoada customization +++ */

/* Load TypeKit CSS asynchronously to prevent render-blocking */
(function() {
  var link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://use.typekit.net/xxe7obs.css';
  link.media = 'print';
  link.onload = function() {
    link.media = 'all';
  };
  document.head.appendChild(link);
})();



/* +++ Ending zoada customization +++ */
